module.exports = __webpack_public_path__ + "img/cat5.fdb36bc.png";